import * as React from 'react'
import { INestedProduct, IChildProduct } from '@getgreenline/homi-shared'
import { Routes } from '../../../../constants/Routes'

interface Props {
  productItem: INestedProduct | IChildProduct
}

export const PrintProductLink = (props: Props) => {
  const { productItem } = props

  return (
    <>
      {productItem.barcode ? (
        <a
          target='_blank'
          href={Routes.PRINTING_CONFIG_VIEW(productItem.companyId, [
            {
              productId: productItem.id,
              quantity: 1,
            },
          ])}
          className='blaze-text-primary'
          rel='noreferrer'
        >
          <span>{`Print ${productItem.name}`}</span>
        </a>
      ) : (
        <span className='blaze-text-muted'>{`${productItem.name} requires barcode`}</span>
      )}
    </>
  )
}
